<template>
    <div>
        <div v-if="reportLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

    <div v-if="reportFound === false && reportLoading === false">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">Sorry...</h2>
            </div>
        </div>
        <div class="widget">
            <div class="widget-body">
                <p>The report could not be found. Please check the URL and try again.</p>
                <p> <router-link to="/">Return Home</router-link></p>
            </div>
        </div>
    </div>
    <div v-if="baeSystemsReport">
        <div class="row align-items-center pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">
                    <router-link to="/bae-systems-reports">
                        BAE Systems Reports</router-link>
                    &raquo;
                    {{ baeSystemsReport.door_identifier }} | {{ baeSystemsReport.door_location }}        </h2>
            </div>
            <div class="col-md-4 d-flex justify-content-end">
                <router-link :to="{ name: 'bae-systems-report-edit', params: {id: baeSystemsReport.site_bae_systems_report_id} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Report
                </router-link>
            </div>
        </div>

        <div class="widget">
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Door ID</strong></td>
                            <td>{{ baeSystemsReport.door_identifier }}</td>
                        </tr>
                        <tr>
                            <td><strong>Building</strong></td>
                            <td>{{ baeSystemsReport.door_location }}</td>
                        </tr>
                        <tr>
                            <td><strong>Zone Floor</strong></td>
                            <td>{{ baeSystemsReport.door_zone_floor }}</td>
                        </tr>
                        <tr>
                            <td><strong>Fire Door Rating</strong></td>
                            <td>{{ baeSystemsReport.door_rating }}</td>
                        </tr>
                        <tr>
                            <td><strong>Door Material</strong></td>
                            <td>{{ baeSystemsReport.door_material }}</td>
                        </tr>
                        <tr>
                            <td><strong>Door Manufacturer and Product Name</strong></td>
                            <td>{{ baeSystemsReport.door_manufacturer }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date of Inspection</strong></td>
                            <td>{{ baeSystemsReport.inspection_date | formatDate }}</td>
                        </tr>
                        <tr>
                            <td><strong>Tested by Who</strong></td>
                            <td>{{ baeSystemsReport.inspector_name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Company</strong></td>
                            <td>{{ baeSystemsReport.company }}</td>
                        </tr>
                        <tr>
                            <td><strong>General Comments</strong></td>
                            <td>{{ baeSystemsReport.comments }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Door Leaf</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Does the door leaf sit against the door stop, flush with the frame and is it free of distortion?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.leaf_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>If the door is veneered or lipped, is the glue still holding these products firmly in place?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.leaf_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the door free from damage affecting its fire integrity?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.leaf_qn_3 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Door Frame</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Is the door frame firmly attached to the wall?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.frame_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>If a planted door stop is present, is it firmly attached?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.frame_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the door to frame gap consistently 4mm or less?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.frame_qn_3 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the door frame free from any damage affecting its fire integrity?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.frame_qn_4 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the fire stopping around the doorframe still in place?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.frame_qn_5 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Intumescent/Smoke/Acoustic Seals</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Are intumescent seals in place? (Including any grills and vents).</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.seals_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the seals free from damage?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.seals_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are smoke seals free from paint or varnish?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.seals_qn_3 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the seals well attached inside the groove in the frame or door leaf?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.seals_qn_4 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the smoke seal in full contact with the door giving an effective seal?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.seals_qn_5 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Hinges</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Is there a minimum of 3 hinges?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hinges_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are all the screws in place and the correct size?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hinges_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the hinges free of metal fragments, oil leakage and signs of wear?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hinges_qn_3 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the hinges free from non-intumescent packing?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hinges_qn_4 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the hinges made from fire rated materials?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hinges_qn_5 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Door Closers</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Open the door to 5 degrees or 75mm. Does it close fully and engage with the latch if fitted?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.closers_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the closer correctly attached to the door and frame?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.closers_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the closer free from damage and oil leakage?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.closers_qn_3 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Does the closer hold the door in line with the frame and intumescent seal?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.closers_qn_4 }}</td>
                        </tr>
                        <tr>
                            <td><strong>If hung in pairs, do they close in line if both opened and released together?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.closers_qn_5 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Hold Open Devices</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Is the device electronically powered?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hold_open_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Does the hold open device release the door when required?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hold_open_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Unable to verify locally</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.hold_open_qn_3 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Lock and Latch</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Does the latch / lock hold the door firmly in place without rattling?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.lock_latch_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are all components correctly fitted and in full working order?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.lock_latch_qn_2 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Glass and Glazing</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Is the intumescent seal continuous and attached to the glass and bead?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.glass_glazing_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Are the glazing beads well attached to the frame and free from damage?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.glass_glazing_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the glass free from damage and cracking?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.glass_glazing_qn_3 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the glass safety rated?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.glass_glazing_qn_4 }}</td>
                        </tr>
                        <tr>
                            <td><strong>Is the glass fire rated?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.glass_glazing_qn_5 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Threshold Gap</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Is there a consistent gap under the door that allows it to swing without touching floor covering?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.threshold_gap_qn_1 }}</td>
                        </tr>
                        <tr>
                            <td><strong>If no drop seal is fitted, is the gap under the door 3mm or less?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.threshold_gap_qn_2 }}</td>
                        </tr>
                        <tr>
                            <td><strong>If a drop seal is fitted is the gap 10mm or less?</strong></td>
                            <td style="width: 80px;text-align:center;">{{ baeSystemsReport.threshold_gap_qn_3 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Signage</h3>
            </div>
            <div class="widget-body">
                <div class="table-responsive">
                    <table class="table table-condensed table-bordered">
                        <tbody>
                            <tr>
                                <td>Main Door:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Closed:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_closed_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Locked:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_locked_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Automatic:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_auto_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>F/Escape:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_f_escape_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Asset Tag:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.main_door_tag_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                            </tr>
                            <tr>
                                <td>Second Door:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Closed:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_closed_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Locked:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_locked_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Automatic:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_auto_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>F/Escape:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_f_escape_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                                <td>Asset Tag:</td>
                                <td>
                                    <label class="styled-checkbox">
                                        <input type="checkbox" v-model="baeSystemsReport.second_door_tag_bool" disabled>
                                        <span class="checkmark"></span>
                                    </label> 
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8"><strong>Is all fire doors signage legible?</strong></td>
                                <td colspan="4">{{ baeSystemsReport.all_fdoors_signage_legible }}</td>
                            </tr>
                            <tr>
                                <td colspan="8"><strong>Is the fire door signage correct as per the door schedule?</strong></td>
                                <td colspan="4">{{ baeSystemsReport.fdoor_signage_correct }}</td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>Other Comment</strong></td>
                                <td colspan="8">{{ baeSystemsReport.signage_comments }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="widget" v-if="baeSystemsReport.bae_systems_report_actions.length > 0">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Actions</h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered" style="width:100%">
                    <thead>
                        <tr>
                            <th>Action Number</th>
                            <th>Part of door/door set</th>
                            <th>Issue</th>
                            <th>Action Priority</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(action, index) in baeSystemsReport.bae_systems_report_actions"
                            v-bind:key="index"
                        >
                            <td style="width: 10%;">{{ index + 1 }}</td>
                            <td style="width: 20%;">{{ action.field_2 }}</td>
                            <td style="width: 50%;">{{ action.field_3 }}</td>
                            <td style="width: 20%;">{{ action.field_4 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="widget" v-if="baeSystemsReport.bae_systems_report_images.length > 0">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Photographs</h3>
            </div>
            <div class="widget-body">
                <div class="row">

                    <item-image
                            v-for="image in baeSystemsReport.bae_systems_report_images"
                            v-bind:key="image.bae_systems_report_image_id"
                            v-bind:image="image"
                    ></item-image>

                </div>
            </div>
        </div>

        <div class="widget" v-if="baeSystemsReport.offline_images.length > 0">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Photographs - Local Images</h3>
            </div>
            <div class="widget-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="alert alert-warning">
                            <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-for="(offlineImage, index) in baeSystemsReport.offline_images" v-bind:key="index">
                        <img v-bind:src="offlineImage.data" class="img-fluid">
                        <div class="image-actions">
                            <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                            <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                        </div>
                        <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                    </div>
                </div>
            </div>
        </div>



    </div>
    </div>
</template>

<script>

    import ItemImage from '../components/ItemImage.vue';
    import ImageRotate from '@/components/mixins/ImageRotate.js'

    export default {
        components: {
            ItemImage
        },
        mixins: [ImageRotate],
        data() {
            return {
                reportFound: false,
                reportLoading: true,
                modifyingPhoto: false,
                baeSystemsReport: null
            }
        },
        methods: {
            getReport() {
                var vm = this;
                this.getDb(function onConnected(db) {

                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('bae_systems_reports').objectStore('bae_systems_reports');
                        var storeRequest = objectStore.get(reportId);


                        storeRequest.onsuccess = function(event) {
                            if (storeRequest.result !== undefined) {
                                let report = storeRequest.result;
                            
                                report.door_material = report.door_material !== undefined ? report.door_material : null;
                                report.door_manufacturer = report.door_manufacturer !== undefined ? report.door_manufacturer : null;
                                report.inspection_date = report.inspection_date !== undefined ? report.inspection_date : null;
                                report.inspector_name = report.inspector_name !== undefined ? report.inspector_name : null;
                                report.company = report.company !== undefined ? report.company : null;
                                report.frame_qn_5 = report.frame_qn_5 !== undefined ? report.frame_qn_5 : null;
                                report.main_door_bool = report.main_door_bool !== undefined ? report.main_door_bool : false;
                                report.main_door_closed_bool = report.main_door_closed_bool !== undefined ? report.main_door_closed_bool : false;
                                report.main_door_locked_bool = report.main_door_locked_bool !== undefined ? report.main_door_locked_bool : false;
                                report.main_door_auto_bool = report.main_door_auto_bool !== undefined ? report.main_door_auto_bool : false;
                                report.main_door_f_escape_bool = report.main_door_f_escape_bool !== undefined ? report.main_door_f_escape_bool : false;
                                report.main_door_tag_bool = report.main_door_tag_bool !== undefined ? report.main_door_tag_bool : false;
                                report.second_door_bool = report.second_door_bool !== undefined ? report.second_door_bool : false;
                                report.second_door_closed_bool = report.second_door_closed_bool !== undefined ? report.second_door_closed_bool : false;
                                report.second_door_locked_bool = report.second_door_locked_bool !== undefined ? report.second_door_locked_bool : false;
                                report.second_door_auto_bool = report.second_door_auto_bool !== undefined ? report.second_door_auto_bool : false;
                                report.second_door_f_escape_bool = report.second_door_f_escape_bool !== undefined ? report.second_door_f_escape_bool : false;
                                report.second_door_tag_bool = report.second_door_tag_bool !== undefined ? report.second_door_tag_bool : false;
                                report.all_fdoors_signage_legible = report.all_fdoors_signage_legible !== undefined ? report.all_fdoors_signage_legible : null;
                                report.fdoor_signage_correct = report.fdoor_signage_correct !== undefined ? report.fdoor_signage_correct : null;
                                report.signage_comments = report.signage_comments !== undefined ? report.signage_comments : null;

                                vm.reportFound = true;
                                vm.baeSystemsReport = report;
                            }
                            vm.reportLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.reportFound = false;
                            vm.reportLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            removePhoto(index) {
                this.modifyingPhoto = true;
                this.baeSystemsReport.offline_images.splice(index, 1);
                var vm = this;
                this.getDb(function onConnected(db) {
                    var putRequest = db.transaction('bae_systems_reports', 'readwrite')
                            .objectStore('bae_systems_reports').put(vm.baeSystemsReport);
                    putRequest.onsuccess = function(event) {
                        vm.modifyingPhoto = false;
                    };
                    putRequest.onerror = function(event) {
                        alert("Unable to remove photo");
                        window.location = '';
                    };
                });
            },
            rotatePhoto(index, degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.baeSystemsReport.offline_images[index].data, degrees).then(newDataUri => {
                    this.baeSystemsReport.offline_images[index].data = newDataUri;

                    var vm = this;
                    this.getDb(function onConnected(db) {
                        var putRequest = db.transaction('bae_systems_reports', 'readwrite')
                            .objectStore('bae_systems_reports').put(vm.baeSystemsReport);
                        putRequest.onsuccess = function(event) {
                            vm.modifyingPhoto = false;
                        };
                        putRequest.onerror = function(event) {
                            alert("Unable to rotate photo");
                            window.location = '';
                        };
                    });
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate photo');
                    this.modifyingPhoto = false;
                });
            }
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('BSR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getReport();
        }
    }
</script>